export const ANIMATION_DURATION_MS = 100;
export const OFFSET = 10;
export const HEIGHT_ANIMATION_DURATION_SECONDS = ANIMATION_DURATION_MS / 1000;
export const VISIBILITY_ANIMATION_DURATION_SECONDS = (ANIMATION_DURATION_MS - OFFSET) / 1000;
